module.exports = __webpack_public_path__ + "static/media/1chul_hyun Translated by J_Lee_77777.8ec6d901.md";